import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddStaffClient.module.scss";
import { CloseIcon } from "Assets/icons";
import { useLazyGetAssociatedClientsQuery, useLazyGetAssociatedClientsWithGradeQuery } from "store/services/utility";
import { debounce } from "lodash";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast, userFullName } from "helpers/common";
import { useUpdateSupportStaffMutation } from "store/services/supportStaff";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { GRADE_OPTIONS } from "config/constants";
import { useGetSchoolListQuery } from "store/services/schools";

const AddStaffClient = ({ show, setShow, staffDetail, staffId }) => {

    const handlePopup = () => setShow(!show);
    const [associatedClientOptions, setAssociatedClientOptions] = useState([]);
    const [filter, setFilter] = useState({ search: "", client_type: "", school:"", grade: "" })
    const [clients, setClients] = useState([]);
    const [updateStaff, { isLoading: updateStaffLoading }] = useUpdateSupportStaffMutation();
    const [validation, setValidation] = useState(null)
    
    const [getAssociatedClients, { isLoading: associatedClientsLoading, isFetching: associatedClientsFetching }] = useLazyGetAssociatedClientsWithGradeQuery();
    
    const { data: schoolList, isLoading: schoolListLoading } = useGetSchoolListQuery({
    search: "",
    status: "active",
    page: 1,
    limit: 100,
    sort: { column: "", direction: "" }
    });


    const getAssociateClientOptions = async () => {

        try {
            const result = await getAssociatedClients(filter);
            if (result.error) return
            setAssociatedClientOptions(result.data);

        } catch (err) { console.log("error fetching associate clients", err) };
    };

    const handleSearch = useCallback(debounce((e) => {
        setFilter((prev) => ({...prev, search: e.target.value}))
    }, 500), [500]);

    const handleCheck = (checked, id) => {

        let list = [...clients];

        if (checked) {

            list.push(id);
            validation && setValidation(null);
        }
        else {

            const index = list.indexOf(id);
            if (index > -1) {
                delete list[index];
            };
        };

        setClients(list.filter(Boolean));
    };

    useEffect(() => {

        if (filter.search || filter.client_type) getAssociateClientOptions();
    }, [filter]);

    useEffect(() => {

        if (staffDetail) setClients(staffDetail?.associated_clients || []);

    }, [staffDetail]);

    const handleSubmit = async () => {

        try {

            if (clients.length == staffDetail?.associated_clients?.length) {

                setValidation("Please select atleast 1 client");
                return;
            }

            handlePopup();
            const result = await updateStaff({ data: { ...staffDetail, associated_clients: clients }, staffId })
            if (result?.error) return console.error("Error create teacher", result.error);

            successMessageToast(result?.data?.message);
        } catch (err) { console.error("Error create teacher", err); }
    };

    return (
        <>
            {updateStaffLoading && schoolListLoading ? <LoadingOverlay /> : null}
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Client List</h6>
                        {/* <p>Select therapist on this perticular role, Selected therapist received notification.</p> */}

                    </div>
                    <Row>
                        <Col className={`${filter?.client_type == "school" ? "col-4" : "col-6"} my-2`}>
                            <div className="iconWithText position-relative">
                                <span className="icn position-absolute" style={{ right: 10 }}>
                                    {searchIcn}
                                </span>
                                <input
                                    type="text"
                                    style={{ paddingRight: 30 }}
                                    placeholder="Search"
                                    className={`${styles.formControl} form-control`}
                                    onChange={handleSearch}
                                />
                            </div>
                        </Col>
                        <Col className={`${filter?.client_type == "school" ? "col-4" : "col-6"} my-2`}>
                            <Form.Select
                                className={`${styles.formControl} form-control`}
                                aria-label="Default select example"
                                defaultValue=""
                                onChange={e => {
                                    setFilter((prev) => ({ ...prev, client_type: e.target.value, school : "" , grade: "" }));
                                }}
                            >
                                {
                                    staffServiceOptions?.map((item, index) => {
                                        return (<option key={index} value={item.value}>{item.label}</option>)
                                    })
                                }
                            </Form.Select>
                        </Col>
                        {
                            filter?.client_type == "school" &&
                          <>
                            <Col className="col-4 my-2">
                                <Form.Select
                                    className={`${styles.formControl} form-control`}
                                    aria-label="Default select example"
                                    defaultValue=""
                                    onChange={e => {
                                        setFilter((prev) => ({ ...prev, school: e.target.value }));
                                    }}
                                >
                                    <option hidden>Select School</option>
                                    {
                                        schoolList?.records?.map((item, index) => {
                                            return (<option key={index} value={item.id}>{item.name}</option>)
                                        })
                                    }
                                </Form.Select>
                            </Col>                            
                            <Col className="col-4 my-2">
                                <Form.Select
                                    className={`${styles.formControl} form-control`}
                                    aria-label="Default select example"
                                    defaultValue=""
                                    onChange={e => {
                                        setFilter((prev) => ({ ...prev, grade: e.target.value }));
                                    }}
                                >
                                    <option hidden>Select Grade</option>
                                    {
                                        GRADE_OPTIONS?.map((item, index) => {
                                            return (<option key={index} value={item.value}>{item.label}</option>)
                                        })
                                    }
                                </Form.Select>
                            </Col>
                          </>
                        }
                        <Col lg="12" className="my-2">
                            {
                                associatedClientsLoading || associatedClientsFetching ? <LoadingIndicator /> : (
                                    <ul className="list-unstyled ps-0 mb-0">
                                        {
                                            associatedClientOptions?.map((item, index) => {
                                                return (
                                                    <li className="py-2" key={index}>
                                                        <div className="d-flex align-items-center justify-content-between gap-10">
                                                            <div className="left d-flex align-items-center gap-10">
                                                                <div className="content">
                                                                    <h6 className="m-0 fw-bold themeBlue">{userFullName(item)}</h6>
                                                                    {/* <p className="m-0 themeBlue">abc-g@gmail.com</p> */}
                                                                </div>
                                                            </div>
                                                            <div className="right">
                                                                <input
                                                                    type="checkbox"
                                                                    style={{ height: 20, width: 20 }}
                                                                    className="form-check"
                                                                    onChange={e => handleCheck(e.target.checked, item.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                )
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center flex-column">
                    <Button
                        type="submit"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                        onClick={handleSubmit}
                    >
                        Save & Send Notification

                    </Button>
                    {validation ? <div className="error">{validation}</div> : null}
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default AddStaffClient;



const searchIcn = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38144 0.235352 8.05579 0.235352 6.48936C0.235352 4.92308 0.777789 3.59697 1.86266 2.51103C2.94754 1.42524 4.27319 0.882339 5.83962 0.882339C7.4059 0.882339 8.73201 1.42493 9.81796 2.51011C10.9037 3.59529 11.4466 4.92125 11.4466 6.48799C11.4466 7.14264 11.3368 7.76788 11.1171 8.36372C10.8973 8.95955 10.604 9.47777 10.2373 9.91838L15.228 14.6076L14.2621 15.5737ZM5.841 10.7189C7.02212 10.7189 8.02251 10.309 8.84216 9.48915C9.66197 8.6695 10.0719 7.66911 10.0719 6.48799C10.0719 5.30686 9.66197 4.30647 8.84216 3.48682C8.02251 2.66701 7.02212 2.25711 5.841 2.25711C4.65987 2.25711 3.65948 2.66701 2.83983 3.48682C2.02003 4.30647 1.61012 5.30686 1.61012 6.48799C1.61012 7.66911 2.02003 8.6695 2.83983 9.48915C3.65948 10.309 4.65987 10.7189 5.841 10.7189Z" fill="#1C1B1F" />
</svg>


const serviceOptions = [
    {
        value: "",
        label: "All Services",
    },
    {
        value: "school",
        label: "School",
    },
    {
        value: "home_education",
        label: "Home Education",
    },
    {
        value: "chatter",
        label: "Chatter",
    },
    {
        value: "private",
        label: "Private",
    }
];
const staffServiceOptions = [
    {
        value: "",
        label: "All Services",
    },
    {
        value: "school",
        label: "School",
    },
    {
        value: "private",
        label: "Private",
    }
];